(ns app.front.view.group.admin.import.property-attribute
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.import.common :as import-session-common]
            [app.front.view.group.admin.import.form-field :as import-form-field]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [re-frame.core-instrumented :as rf]))

(defmethod import-session-common/entities-cols :import-session.type/property-attributes [_]
  (let [tr (<sub [::import-session-common/property-tr])]
    [[(tr [:property/id]) :property/id]]))

(defmethod import-session-common/entity-href :import-session.type/property-attributes [_ property]
  (href/href :view/property {:db-id (:db/id property)}))

(rf/reg-sub ::enabled-attribute-templates
  :<- [::entities/context]
  :<- [::gas/group]
  (fn [[ctx group] _]
    (let [entities (entities/find-entities
                     ctx {:property-attribute-template/group (:db/id group)
                          :domain/state                      :property-attribute-template.state/enabled})]
      (sort-by :ordered/order entities))))

(rf/reg-sub ::selectable-property-attribute-options
  :<- [::enabled-attribute-templates]
  (fn [attribute-templates [_ _ {:keys [property-attribute-template-id]}]]
    (->> attribute-templates
         (filter #(= (:db/id %) property-attribute-template-id))
         first
         :property-attribute-template/options
         (sort-by :ordered/order))))

(def property-attribute-mapping-settings
  (import-session-common/string-to-value-mapping-settings
    :data-import.mapping/property-attribute
    ::selectable-property-attribute-options
    :db/id
    (fn [item lang]
      (i18n-model/get-text-from-entities-or-map
        (:property-attribute-template-option/values item) lang))))

(defmethod import-session-common/mapping-settings
  [:data-import.mapping/property-attribute :property-attribute-template.type/select] [props]
  [property-attribute-mapping-settings props])

(defmethod import-session-common/mapping-settings
  [:data-import.mapping/property-attribute :property-attribute-template.type/integer] [props]
  [import-form-field/form-field-mapping-settings props])

(defmethod import-session-common/mapping-settings
  [:data-import.mapping/property-attribute :property-attribute-template.type/decimal] [props]
  [import-form-field/form-field-mapping-settings props])

(defmethod import-session-common/mapping-settings
  [:data-import.mapping/property-attribute :property-attribute-template.type/text] [props]
  [import-form-field/form-field-mapping-settings props])

(defmethod import-session-common/mapping-settings
  [:data-import.mapping/property-attribute :property-attribute-template.type/toggle] [props]
  [import-form-field/form-field-mapping-settings props])

(defmethod import-session-common/mapping-settings
  [:data-import.mapping/property-attribute :property-attribute-template.type/date] [props]
  [import-form-field/form-field-mapping-settings props])
